import React from "react";

const scrollToSection = (id) => {
  const element = document.getElementById(id);
  if (element) {
    element.scrollIntoView({ behavior: "smooth" });
  }
};

const Nav = () => (
  <nav style={styles.section}>
    <ul style={styles.list}>
      <li style={styles.listItem}>
        <button style={styles.link} onClick={() => scrollToSection("services")}>
          Servicios
        </button>
      </li>
      <li style={styles.listItem}>
        <button style={styles.link} onClick={() => scrollToSection("benefits")}>
          Beneficios
        </button>
      </li>
      <li style={styles.listItem}>
        <button style={styles.link} onClick={() => scrollToSection("about")}>
          Acerca
        </button>
      </li>
      <li style={styles.listItem}>
        <button style={styles.link} onClick={() => scrollToSection("contact")}>
          Contacto
        </button>
      </li>
    </ul>
  </nav>
);

const styles = {
  section: {},
  list: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    listStyle: "none",
    fontSize: "1.2rem",
    lineHeight: "1.6",
    paddingLeft: "20px",
  },
  listItem: { listStyle: "none" },
  link: {
    fontFamily: "Outfit, sans-serif",
    textDecoration: "none",
    background: "none",
    border: "none",
    color: "#AC4896",
    fontSize: "1.2rem",
    letterSpacing: ".03rem",
    textTransform: "uppercase",
    marginLeft: "1rem",
    cursor: "pointer",
  },
};

export default Nav;
